export default ({ loaded, total }: any) => Math.round((loaded * 100) / total);
